import { useMemo } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getNetworkVpcs } from '../api';
import type { NetworkSelectOptionItem, UseNetworkVpcOptionsParams } from '../types';
import { mapNetworkSelectOptions } from '../utils';

export function useNetworkVpcOptions({ ws, dc, enabled = true }: UseNetworkVpcOptionsParams) {
  const swrKey = enabled && ws ? { key: 'NETWORK_VPC_OPTIONS', ws, dc: dc ?? null } : null;

  const { data, error, isLoading } = useSWR(
    swrKey,
    ({ ws: workspace, dc: datacenter }) => getNetworkVpcs({ ws: workspace, dc: datacenter ?? undefined }),
    {
      revalidateOnFocus: false,
    },
  );

  const options = useMemo<NetworkSelectOptionItem[]>(() => {
    if (!data) return [];
    return mapNetworkSelectOptions(get(data, 'items', []), 'vpc');
  }, [data]);

  return { options, isLoading, error, isReady: !isLoading };
}
